module.exports = __webpack_public_path__ + "static/media/ifps-logotypy.c9f934d9.jpg";